import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import getContents from '../../routes/websiteRoutes';

const PAGE_404 = lazy(() => import('../../pages/auth/Page404'));
const WebsiteRoutes = () => {
	return (
		<Routes>
			{getContents().map((page) => (
				<Route key={page.path} {...page} />
			))}
			<Route path='*' element={<PAGE_404 />} />
		</Routes>
	);
};

export default WebsiteRoutes;
